import React, { useEffect, useState } from "react";
import { useSnippetResolver } from "../content-management/ContentManagementProvider";
export const SnippetDisplay = (props) => {
    const resolver = useSnippetResolver();
    const [html, setHtml] = useState("");
    useEffect(() => {
        resolver(props.snippetId).then((html) => setHtml(html));
    }, [props.snippetId]);
    return (React.createElement("div", { dangerouslySetInnerHTML: { __html: html } }));
};
